import { FunctionComponent } from 'react'
import parse from 'html-react-parser'

const QuestionText: FunctionComponent<{ question: string }> = (props) => {
  return (<h1 className="mb-5 ml-2 mr-2">{parse(String(props.question))}</h1>)
}

export default QuestionText
